import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import CommunityHeader from "./CommunityHeader";
import CommunityPosts from "./CommunityPosts";
import CommunityWrapper from "./CommunityStyle";
import { getCookie } from "components/common/cookie";
import { useSelector } from "react-redux";

function Community() {
  const navigate = useNavigate();

  // 토큰값 유무 확인 후, 없으면 로그인화면으로 redirect
  const isLogin = getCookie("AccessToken") ? true : false;
  useEffect(() => {
    !isLogin && navigate("/login", { replace: true });
  }, [navigate, isLogin]);

  const { accusePosts, accuseComments, accuseRecomments } = useSelector(
    (state) => state.post,
  );
  console.log(
    "신고포스트",
    accusePosts,
    "신고댓글",
    accuseComments,
    "신고답글",
    accuseRecomments,
  );

  return (
    <CommunityWrapper>
      <CommunityHeader />
      <CommunityPosts />
    </CommunityWrapper>
  );
}

export default Community;
